var styles = {"box":"AccordionSelect_box_m7p19_1","accordion-select":"AccordionSelect_accordion-select_m7p19_6","point":"AccordionSelect_point_m7p19_168","hovered":"AccordionSelect_hovered_m7p19_198","close-transition":"AccordionSelect_close-transition_m7p19_208"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
